import React from 'react';
import { useField } from 'react-final-form';

import { FWorkflowTriggerFragment } from '@dashboard/generated/wp/platform';

import ApiExample from '../ApiExample';
import { UpdateWorkflowKeyDropdown } from '../ApiExample/WorkflowKeyDropdown';
import TriggerSectionWrapper from '../TriggerSectionWrapper';

type Props = {
  name: string;
};
export default function WorkflowKeyTriggerCard({ name }: Props) {
  const { value } = useField<FWorkflowTriggerFragment>(name).input;
  return (
    <TriggerSectionWrapper type="WAYPOINT_API">
      <ApiExample
        customKeyValue={value.workflowKey?.key}
        customKeyDropdown={<UpdateWorkflowKeyDropdown name={name} />}
      />
    </TriggerSectionWrapper>
  );
}
